import StatusPage from "./StatusPage";
import { Button, ButtonProps } from "@/components/ui/Button";
import { twMerge } from "tailwind-merge";

interface Props {
  title?: string;
  description?: string;
  actionButton?: ButtonProps;
}

const ErrorPage = ({ title, description, actionButton }: Props) => {
  return (
    <StatusPage
      icon={"/error-page.svg"}
      title={title ?? "We’re having trouble"}
      description={
        description ??
        "Looks like something isn’t working as expected. Please notify the practice."
      }
      footer={
        actionButton && (
          <Button
            size="lg"
            color="primary"
            variant="contained"
            {...actionButton}
            className={twMerge(
              "mx-auto w-full max-w-[260px]",
              actionButton.className,
            )}
          >
            {actionButton.children ?? "Try Again"}
          </Button>
        )
      }
    />
  );
};

export default ErrorPage;
